import type { ButtonHTMLAttributes, ReactNode } from "react";
import { useIdioma } from "../../i18n/IdiomaProvider";
import styles from "./BotaoIcone.module.css";

interface BotaoIconeProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  titulo: string;
  ativo?: boolean;
  pequeno?: boolean;
  grande?: boolean;
  perigo?: boolean;
  children: ReactNode;
}

/**
 * Botão apenas com ícone (engrenagem, atualizar, alternar tema, ações de linha).
 * Acessível: usa `titulo` como aria-label e tooltip CUSTOMIZADO (não nativo),
 * no mesmo padrão do legado (classe .tooltip + data-tooltip).
 */
export function BotaoIcone({
  titulo,
  ativo = false,
  pequeno = false,
  grande = false,
  perigo = false,
  children,
  className,
  type,
  ...rest
}: BotaoIconeProps) {
  const { traduzir } = useIdioma();
  const tituloTraduzido = traduzir(titulo);
  const classes = [
    styles.botao,
    "botao-icone",
    "tooltip",
    pequeno ? styles.pequeno : "",
    grande ? styles.grande : "",
    ativo ? styles.ativo : "",
    perigo ? styles.perigo : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <button
      type={type ?? "button"}
      className={classes}
      aria-label={tituloTraduzido}
      aria-pressed={ativo || undefined}
      data-tooltip={tituloTraduzido}
      {...rest}
    >
      {children}
    </button>
  );
}
